import React from 'react'
import classNames from 'classnames'

import Link from 'content-components/_Primatives/Link'

type Props = {
  above?: React.ReactNode
  children?: React.ReactNode
  className?: string
  isActive?: boolean
  style?: {
    active?: string
    link?: string
    linkWithSubMenu?: string
    menuItem?: string
  }
  target?: string
  text: string
  url: string
}

MenuItem.defaultProps = {
  above: undefined,
  className: '',
  isActive: false,
  style: {
    active: '',
    menuItem: undefined,
    link: undefined,
    linkWithSubMenu: '',
  },
  url: '',
  target: '',
  children: null,
}

function MenuItem(props: Props) {
  const {
    above,
    children,
    isActive,
    url,
    target,
    text,
    style = {},
    className,
  } = props

  return (
    <li className={style.menuItem}>
      {above}
      <Link
        className={classNames(
          style.link,
          { [style.active || '']: isActive },
          { [style.linkWithSubMenu || '']: !!children },
          className,
        )}
        target={target}
        url={url}
      >
        {text}
      </Link>
      {children} {/* Children will only ever be SubMenu. */}
    </li>
  )
}

export default MenuItem
